import Reseñas from "./reseñas";


const Opiniones = ()=>{
    return(
        <section 
        id="Reseñas"
        className="relative h-screen snap-start flex flex-col items-center justify-center"
        style={{
        background:
          "linear-gradient(180deg, #F3FEFF 0%, #EFE6D8 49.52%, #D8C4A5 90.38%)",
      }}>
        <Reseñas />
        

        </section>
        
    )
}
export default Opiniones;